import React, { useState } from 'react';
import { useHistory } from "react-router-dom";
import { useSelector } from 'react-redux';
import { RoleMasterService } from "../../services";
import { ConfirmDialog, WarnDialog } from '../../components/shared';
import 'date-fns';
import { Chip, Button, Backdrop, Card, CircularProgress, Container, Grid, InputLabel } from '@material-ui/core';
import { Formik, Form, useFormik } from 'formik';
import { makeStyles } from '@material-ui/core/styles';
import 'react-medium-image-zoom/dist/styles.css'

const useStyles = makeStyles((theme) => ({
    pageTitleDiv: {
        marginTop: 20,
    },
    pageTitle: {
        paddingTop: 6,
        paddingBottom: 6,
        paddingLeft: 0,
        fontSize: 18,
        color: theme.palette.text.secondary,
        textTransform: 'uppercase'
    },
    formCard: {
        display: 'flex',
        marginTop: 10,
        marginBottom: 10,
        paddingTop: 12,
        paddingBottom: 12,
        backgroundColor: theme.palette.background.paper,
    },
    innerGrid: {

    },
    form: {
        display: 'flex',
        flexWrap: 'wrap',
    },
    formFieldContainer: {
        display: 'flex',
        width: '100%',
        marginRight: '1rem',
        marginLeft: '1rem',
        marginBottom: 8,
        marginTop: 8
    },
    inputLabel: {
        marginLeft: '1rem',
        marginRight: '1rem',
        width: '8rem',
        fontSize: 14,
        zIndex: 1000,
        lineHeight: 1.75,
        textTransform: 'uppercase',
        fontWeight: 'bold',
        display: 'flex',
        alignItems: 'center'
    },
    fakeInput: {
        borderStyle: 'solid',
        borderColor: 'lightgray',
        borderWidth: '0.5px',
        width: '100%',
        padding: 7,
        borderRadius: '3px'
    },
    textField: {
        width: 260,
        marginTop: 'auto',
        marginBottom: 'auto',
    },
    prefix: {
        width: 100,
        marginRight: 5
    },
    cancelButton: {
        padding: 8,
        width: 90,
        alignSelf: 'center'
    },
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
    },
}));

function nullToString(obj) {
    for (var i in obj) {
        if (obj[i] === null) {
            obj[i] = ''
        }
    }
    return obj;
}

function fixDate(date) {
    if (!date) {
        return ''
    } else {
        if (typeof date === 'string') {
            return date.substring(0, 10)
        } else {
            return date.toString().substring(0, 10)
        }
    }
}

export default function EmailAuditDetails(props) {
    const dataPassedFromTable = useSelector((state) => state.emailAudit.formDataFromTableEmailAudit);
    const history = useHistory();
    const classes = useStyles();

    const [formData, setFormData] = useState(nullToString(dataPassedFromTable))
    const [isLoading, setIsLoading] = useState(false);

    const [confirmDialog, setConfirmDialog] = useState({ isOpen: false, title: '', subTitle: '' })
    const [warnDialog, setWarnDialog] = useState({ isOpen: false, title: '', subTitle: '' });

    const formik = useFormik({
        initialValues: formData,
        onSubmit: async (values) => {
            try {
                await RoleMasterService.saveRole(values)
                history.push('/admin/role-master/home')
            } catch (e) {
                console.log(e.message)
            }
        },
    });

    //if page reload, send user back to home
    if (Object.keys(formData).length === 0) {
        history.push('/admin/email-audit/home')
    }

    if (isLoading) {
        return (
            <Backdrop className={classes.backdrop} open={isLoading}>
                <CircularProgress color="inherit" />
            </Backdrop>)
    }
    return (
        <>
            <Container>
                <div className={classes.pageTitleDiv}>
                    <h2 className={classes.pageTitle}>
                        Email Details
                    </h2>
                </div>

                <Grid container spacing={3}>
                    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', marginTop: 10, marginBottom: 10 }}>
                        <Button className={classes.cancelButton} onClick={() => history.push('/admin/email-audit/home')} size='small' variant='contained' color='default'>
                            Back
                    </Button>
                    </div>
                    <Card className={classes.formCard}>
                        <Grid item xs={12} sm={12} md={12} lg={12} className={classes.innerGrid}>
                            <Formik>
                                <Form
                                    className={classes.form}
                                    onSubmit={formik.onSubmit}
                                >
                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Subject:
                                   </InputLabel>
                                        <div className={classes.fakeInput}>
                                            {formik.values.emailSubject}
                                        </div>
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            From:
                                   </InputLabel>
                                        <div className={classes.fakeInput}>
                                            {formik.values.senderEmail}
                                        </div>
                                    </div>

                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Date:
                                   </InputLabel>
                                        <div className={classes.fakeInput}>
                                            {fixDate(formik.values.createDate)}
                                        </div>
                                    </div>
                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            To:
                                   </InputLabel>
                                        <div className={classes.fakeInput}>
                                            {formik.values?.recipientEmail?.split(';').map((v, i) =>
                                                <Chip
                                                    label={v}
                                                    size='small'
                                                    variant='outlined'
                                                    color='default'
                                                    style={{ padding: 4, marginLeft: 3, marginRight: 3, marginTop: 2, marginBottom: 2 }}
                                                />)
                                            }
                                            </div>
                                    </div>
                                    <div className={classes.formFieldContainer}>
                                        <InputLabel className={classes.inputLabel}>
                                            Mail Body:
                                   </InputLabel>
                                        <div
                                            dangerouslySetInnerHTML={{ __html: formik.values.emailBody }}
                                            style={{ borderStyle: 'solid', borderColor: 'lightgray', borderWidth: '0.5px', padding: 20, borderRadius: '4px', width: '100%', fontStyle: 'italic' }}
                                        ></div>
                                    </div>
                                </Form>
                            </Formik>
                        </Grid>
                    </Card>
                </Grid>

            </Container >
            <ConfirmDialog
                confirmDialog={confirmDialog}
                setConfirmDialog={setConfirmDialog}
            />
            <WarnDialog
                warnDialog={warnDialog}
                setWarnDialog={setWarnDialog}
            />
            <Backdrop className={classes.backdrop} open={!formik.values}>
                <CircularProgress color="inherit" />
            </Backdrop>
        </>
    );
};